module.exports = __webpack_public_path__ + "assets/osde.0a2b8b17.svg";